<template>
  <div class="side_menu">
    <!-- title -->
    <div class="tit">
      <h2 class="tit_name">{{ topMenu.title }}</h2>
    </div>
    <div class="side_nav">
      <ul class="side_list">
        <li v-for="item in sideMenu">
          <!-- <a :href="item.link">{{ item.name }}</a> -->
          <router-link :to="{ name: item.link }">{{ item.name }}</router-link>
          <ul class="sub_menu">
            <li v-for="i in item.sub">
              <!-- <a :href="i.link">&ndash; {{ i.name }}</a> -->
              <router-link :to="{ name: i.link }">&ndash; {{ i.name }}</router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },

  props: {
    sideMenu: Array,
    topMenu: Object,
  },
  methods: {
    toggleShow() {
      this.show = !this.show
    },
  },
  created() {},
}
</script>

<style>
/* 헤더 밑 */

.side_menu {
  margin: 0;
  padding: 0;
  position: relative;
  float: left;
  margin-left: 200px;
}
.side_menu .tit {
  padding-top: 30px;
  padding-bottom: 20px;
  position: relative;
  vertical-align: top;
}
.side_menu .tit h2 {
  font-size: 30px;
  font-weight: 600;
  color: #494949;
  /* width: 1300px; */
  /* margin-top: 20px; */
}

.side_menu .side_nav {
  position: relative;
  font-size: 30px;
  font-weight: 600;
  color: #494949;
  width: 205px;
  height: 700px;
  border-right: 1px solid rgb(173, 169, 169, 0.5);
  margin-right: 0;
  padding: auto;
  float: left;
}
.side_menu .side_nav .side_list {
  list-style: none;
  padding-left: 0;
  float: left;
}
.side_menu .side_nav .side_list li {
  display: inline-block;
  width: 301px;
  height: 60px;
}
.side_menu .side_nav .side_list a {
  color: #000;
  text-decoration: none;
  font-weight: 500;
  font-size: 18px;
  letter-spacing: 1px;
}

.side_menu .side_nav .side_list li .sub_menu {
  padding-left: 0;
  /* height: 60px; */
}
.side_menu .side_nav .side_list li .sub_menu li {
  height: 0;
}
.side_menu .side_nav .side_list li .sub_menu li a {
  font-size: 15px;
}

@media (max-width: 1500px) {
  .content_wrap {
    width: 50%;
  }
  .side_menu {
    margin-left: 100px;
    left: 0;
  }
}
@media (max-width: 960px) {
  .content_wrap {
    display: flex;
    flex-direction: column;
  }
  .side_menu {
    margin-left: 0;
  }
  .side_menu .tit {
    display: none;
  }
  .side_menu .side_nav {
    width: 100%;
    height: 60px;
  }
  .side_menu .side_nav .side_list {
    width: 100%;
    padding-top: 0;
    margin-bottom: 0;
    display: flex;
    flex-wrap: wrap;
  }
  .side_menu .side_nav .side_list li {
    width: 33.33%;
  }
  .side_menu .side_nav .side_list a {
    display: inline-block;
    width: 100%;
    text-align: center;
    line-height: 58px;
    font-weight: 400;
    font-size: 20px;
    color: #777;
    border: 1px solid #ddd;
    border-left: 0;
  }

  .side_menu .side_nav .side_list a:hover {
    background-color: rgba(3, 40, 119, 0.212);
  }
  .side_menu .side_nav .side_list li .sub_menu {
    width: 500px;
  }
  /* .side_menu .side_nav .side_list li .sub_menu li {
  } */
  .side_menu .side_nav .side_list li .sub_menu a {
    /* border-top: none; */
    border: none;
    width: 170px;
    text-align: center;
  }
  .side_menu .side_nav .side_list li .sub_menu a:hover {
    background: none;
    color: rgb(69, 122, 235);
  }
}
@media (max-width: 650px) {
  .side_menu .side_nav .side_list a {
    font-size: 16px;
  }
}
</style>
